import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from '@daisi/components/app/app.component';
import { LicenseManager, provideGlobalGridOptions, themeQuartz } from 'ag-grid-enterprise';
import { AG_GRID_LOCALE_NL } from '@ag-grid-community/locale';
import { environment } from '@env/environment';
import { ndwAgGridTheme } from '@ndwnu/design-system';

LicenseManager.setLicenseKey(environment.agGrid?.key ?? 'invalid-license-key');
provideGlobalGridOptions({
  theme: themeQuartz.withParams(ndwAgGridTheme),
  localeText: AG_GRID_LOCALE_NL,
});
// Dummy handler to fix issue with zone.js and MapLibre map
// https://github.com/angular/angular/issues/45020
document.addEventListener('mousemove', () => {}, {
  passive: false,
  capture: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
